import React, { useCallback, useState, useEffect, useMemo } from "react";
import {
  serviceGetChatCoAdmin,
  serviceGetEmployeeList,
} from "../../../../../services/Chat.service";
import SnackbarUtils from "../../../../../libs/SnackbarUtils";

const useCoAdminHook = ({
  groupId,
  handleUpdateGroup,
  handleClosepopOver,
  fetchChatInfo,
  renderConversation,
  coAdminIds = [],
}) => {
  const [selected, setSelected] = useState([]);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [isDialog, setIsDialog] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const totalShow = 10;

  useEffect(() => {
    if (coAdminIds && allData?.length) {
      const adminIdSet = new Set(coAdminIds);
      const filteredData = allData?.filter((item) => adminIdSet?.has(item?.id));
      setSelected(filteredData);
    }
  }, [coAdminIds, allData]);

  const fetchList = () => {
    setIsFetching(true);
    serviceGetEmployeeList()
      .then((res) => {
        const list = !res?.error && res?.data ? res.data : [];
        setAllData(list);
        setData(list);
        setCurrentPage(1);
      })
      .finally(() => {
        setIsFetching(false);
      });
  };
  console.log("selected", selected);

  const handleAddCoAdmin = useCallback(() => {
    if (!selected?.length) {
      SnackbarUtils.error("Please add atleast one employee");
      return ;
    }
    if (!loading) {
      setLoading(true);
      serviceGetChatCoAdmin({
        group_id: groupId,
        employee_ids: selected?.map((val) => val?.id) || [],
      }).then((res) => {
        if (!res.error) {
          SnackbarUtils.success("Co Admin Added successfully");
          handleUpdateGroup();
          handleClosepopOver();
          fetchChatInfo();
          renderConversation();
        } else {
          SnackbarUtils.error(res?.message);
        }
        setLoading(false);
      });
    }
  }, [setLoading, loading, groupId, selected]);
  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    _processData();
  }, [currentPage, data]);

  //   useEffect(() => {
  //     if (!editEmployee?.employees?.length > 0) {
  //       if (allData?.length > 0 && selected?.length > 0) {
  //         const filtered = selected.filter((sel) =>
  //           allData.some((data) => data.id === sel.id)
  //         );
  //         setSelected(filtered);
  //       } else if (allData?.length === 0) {
  //         setSelected([]);
  //       }
  //     }
  //   }, [allData]);

  const _processData = () => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  };

  const handlePageChange = useCallback(
    (type) => {
      console.log("_handlePageChange", type);
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
      }
    },
    [data, totalShow]
  );

  const queryFilter = useCallback((key, value) => {
    console.log("_queryFilter", key, value);
  }, []);

  const handleFilterDataChange = useCallback(
    (value) => {
      console.log("_handleFilterDataChange", value);
      queryFilter("FILTER_DATA", value);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      console.log("_handleSearchValueChange", value);
      queryFilter("SEARCH_TEXT", value);
      let tempData = allData;
      if (value) {
        tempData = allData.filter((val) => {
          return (
            val?.emp_code?.match(new RegExp(value, "ig")) ||
            val?.name?.match(new RegExp(value, "ig"))
          );
        });
      }

      setCurrentPage(1);
      setData(tempData);
    },
    [queryFilter, allData]
  );

  const handleSortOrderChange = useCallback((row, order) => {
    console.log(`handleSortOrderChange key:${row} order: ${order}`);
  }, []);

  const handleRowSize = (page) => {
    console.log(page);
  };

  const handleRowSelection = (page) => {
    console.log(">>>>>>>", page);
  };

  const handleCheckbox = useCallback(
    (data) => {
      const tempSelected = JSON.parse(JSON.stringify(selected));
      const tempIndex = tempSelected.findIndex((sel) => sel.id === data.id);
      if (tempIndex >= 0) {
        tempSelected.splice(tempIndex, 1);
      } else {
        tempSelected.push(data);
      }
      setSelected(tempSelected);
    },
    [selected]
  );
  const selectAllEmployee = useCallback(
    (e) => {
      if (e.target.checked) {
        setSelected(allData);
      } else {
        setSelected([]);
      }
    },
    [selected, setSelected, allData]
  );

  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleRowSize,
    handleSortOrderChange,
    handleCheckbox,
    selected,
    currentPage,
    currentData,
    data,
    allData,
    isFetching,
    isDialog,
    handleRowSelection,
    selectAllEmployee,
    handleAddCoAdmin,
    loading,
  };
};

export default useCoAdminHook;
